<template>
  <div class="Tracks">
    <div class="track" @click="selectBGM01">
      <p v-if="bgm01" class="m-ellipsis"><faicon class="icon" icon="music" /> {{bgm01.name}}</p>
      <p v-if="!bgm01"><faicon class="icon" icon="music" /> - - - - -</p>
      <!-- <audio ref="bgm01"></audio> -->
      <vaudio v-if="bgm01" :src="bgm01.url" :loop="bgm01.loop" :volume="bgm01.volume" :muted="muted" :autoplay="true" />
    </div>
    <div class="track" @click="selectBGM02">
      <p v-if="bgm02" class="m-ellipsis"><faicon class="icon" icon="music" /> {{bgm02.name}}</p>
      <p v-if="!bgm02"><faicon class="icon" icon="music" /> - - - - -</p>
      <vaudio v-if="bgm02" :src="bgm02.url" :loop="bgm02.loop" :volume="bgm02.volume" :muted="muted" :autoplay="true" />
    </div>
    <div class="track" @click="selectSE01">
      <p v-if="se01" class="m-ellipsis">[SE] {{se01.name}}</p>
      <p v-if="!se01">[SE] - - - - -</p>
      <vaudio v-if="se01" :src="se01.url" :loop="se01.loop" :volume="se01.volume" :muted="muted" :autoplay="true" />
    </div>
    <a class="mute" :class="{ muted: muted }" @click="mute">
      <span class="mute-icon"><faicon class="icon" icon="volume-down" /></span>
      {{ muted ? 'unmute' : 'mute' }}
    </a>
    <!-- <a class="reload" @click="reload"><faicon class="icon" icon="sync" /> reload</a> -->
  </div>
</template>

<script>
import draggable from '../common/draggable'
import vaudio from '../common/audio'
// import vaudio from 'vue-audio'
// const TRACKS = [
//   { key: 'bgm01', volume: 0.2 },
//   { key: 'bgm02', volume: 0.3 },
//   { key: 'se01', volume: 0.3 }
// ]
export default {
  components: { draggable, vaudio },
  computed: {
    bgm01SoundKey() {
      return this.$store.getters['room/bgm01SoundKey']
    },
    bgm02SoundKey() {
      return this.$store.getters['room/bgm02SoundKey']
    },
    se01SoundKey() {
      return this.$store.getters['room/se01SoundKey']
    },
    muted() {
      return this.$store.getters['local/muted']
    },
    bgm01() {
      return this.get(this.bgm01SoundKey)
    },
    bgm02() {
      return this.get(this.bgm02SoundKey)
    },
    se01() {
      return this.get(this.se01SoundKey)
    },
    get() {
      return this.$store.getters['sounds/$get']
    }
  },
  watch: {
    // bgm01SoundKey(key) {
    //   const track = TRACKS[0]
    //   this.$nextTick(() => {
    //     const sound = this.get(key)
    //     const audio = this.$refs[track.key]
    //     if (sound && audio) {
    //       audio.src = sound.url
    //       audio.volume = sound.volume ? sound.volume * 0.01 : track.volume
    //       audio.loop = !!sound.loop
    //       audio.muted = this.muted
    //       audio.load()
    //       audio.play()
    //     } else if(audio) {
    //       audio.pause()
    //     }
    //   })
    // },
    // bgm02SoundKey(key) {
    //   const track = TRACKS[1]
    //   this.$nextTick(() => {
    //     const sound = this.get(key)
    //     const audio = this.$refs[track.key]
    //     if (sound && audio) {
    //       audio.src = sound.url
    //       audio.volume = sound.volume ? sound.volume * 0.01 : track.volume
    //       audio.loop = !!sound.loop
    //       audio.muted = this.muted
    //       audio.load()
    //       audio.play()
    //     } else if(audio) {
    //       audio.pause()
    //     }
    //   })
    // },
    // se01SoundKey(key) {
    //   const track = TRACKS[2]
    //   this.$nextTick(() => {
    //     const sound = this.get(key)
    //     const audio = this.$refs[track.key]
    //     if (sound && audio) {
    //       audio.src = sound.url
    //       audio.volume = sound.volume ? sound.volume * 0.01 : track.volume
    //       audio.loop = !!sound.loop
    //       audio.muted = this.muted
    //       audio.load()
    //       audio.play()
    //     } else if(audio) {
    //       audio.pause()
    //     }
    //   })
    // }
  },
  methods: {
    // reload() {
    //   TRACKS.forEach(({ key, volume }) => {
    //     const audio = this.$refs[key]
    //     if (audio && audio.src) {
    //       // audio.volume = volume
    //       audio.load()
    //       audio.play()
    //     } else if(audio) {
    //       audio.pause()
    //     }
    //   })
    // },
    mute() {
      const muted = !this.muted
      this.$store.commit('local/set', { key: 'muted', value: muted })
      // TRACKS.forEach(({ key, volume }) => {
      //   const audio = this.$refs[key]
      //   if (audio) {
      //     audio.muted = muted
      //   }
      // })
    },
    selectBGM01() {
      this.$store.commit('selectors/openSound', {
        tags: ['bgm'],
        action: 'room/$set',
        context: { key: 'bgm01SoundKey' }
      })
    },
    selectBGM02() {
      this.$store.commit('selectors/openSound', {
        tags: ['bgm2'],
        action: 'room/$set',
        context: { key: 'bgm02SoundKey' }
      })
    },
    selectSE01() {
      this.$store.commit('selectors/openSound', {
        tags: ['se'],
        action: 'room/$set',
        context: { key: 'se01SoundKey' }
      })
    }
  }
}
</script>

<style scoped>
.Tracks {
  padding: 0 7px;
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
}
.track {
  margin-right: 8px;
  max-width: 90px;
  opacity: 0.4;
  cursor: pointer;
}
.track:hover {
  opacity: 1;
}
.track p {
  font-size: 10px;
  color: #fff;
}
.reload, .mute {
  padding: 2px 4px;
  position: relative;
  cursor: pointer;
  color: #fff;
  font-size: 12px;
  opacity: 0.4;
}
/* .mute {
  margin-right: 4px;
} */
.reload {
  font-size: 11px;
}
.reload:hover, .mute:hover {
  opacity: 1;
}
.mute-icon {
  position: relative;
}
.mute.muted .mute-icon::after, .mute:hover .mute-icon::after {
  content: "";
  border-top: 1px solid #fff;
  border-bottom: 1px solid #222;
  width: 14px;
  height: 0;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -45%) rotate(45deg);
}
</style>
